import { Stack } from '@mantine/core'
import { FileUploadButton } from './file-upload-button'
import { OrderFile } from '../../../../../../services'
import { OrderFileView } from './proposal-file-view'
import { NoProposalFiles } from './no-proposal-files'
import { useProposalFilesView } from './proposal-files-view.hook'

type ProposalFilesViewProps = {
  isLoading: boolean;
  proposalFiles: Array<OrderFile>;
  onAttachFiles: (files: Array<File>) => void;
  onRemoveFile: (fileName: string) => void;
  canEdit: boolean;
}

export function ProposalFilesView({
  isLoading,
  proposalFiles,
  onAttachFiles,
  onRemoveFile,
  canEdit,
}: ProposalFilesViewProps) {
  const { onUploadFiles } = useProposalFilesView({ proposalFiles, onAttachFiles })

  return (
    <Stack justify='space-between'>
      {proposalFiles.length === 0 && (
        <NoProposalFiles/>
      )}
      {proposalFiles.length > 0 && (
        <div style={{ minHeight: 100 }}>
          <div>
            {proposalFiles.map(({ filename, s3Url, data }, index) => (
              <OrderFileView
                key={filename}
                filename={filename}
                index={index}
                s3Url={s3Url}
                data={data}
                isLoading={isLoading}
                hasRemoveButton={canEdit}
                onRemoveFile={onRemoveFile}
              />
            ))}
          </div>
        </div>
      )}
      {canEdit && (
        <div className='flex space-x-2 justify-end mt-4'>
          <FileUploadButton
            isLoading={isLoading}
            onUploadFiles={onUploadFiles}
          />
        </div>
      )}
    </Stack>
  )
}
